import { all, fork, takeEvery, takeLatest, put, select } from "redux-saga/effects";
import { membersApi, registerApi, authApi } from '../../api/index';
import { MembersActionTypes, BetSlipActionTypes, SignalRTypes, AuthActionTypes, GeneralActionTypes } from '../actions';
import { Cookies, Utils, Enums, SessionStorage } from '../../helpers';
import moment from 'moment';

export function* requests() {

    function* refreshToken() {

        try {
            window.log("!member saga ")
            const expTokenDateTime = Cookies.get("expTokenDateTime");
            const refreshToken = Cookies.get("refreshToken");
            const { app } = yield select();
            const { serverTime } = app;
            // console.log("!expTokenDateTime", expTokenDateTime)
            window.log("!moment(serverTime)", Utils.formatDate(serverTime))
            window.log("!moment(expTokenDateTime", Utils.formatDate(expTokenDateTime))
            // console.log("!oment(serverTime) > moment(expTokenDateTime)", moment(serverTime) > moment(expTokenDateTime))
            if (moment(serverTime) > moment(expTokenDateTime) || !expTokenDateTime) {
                console.log("!need to refreshToken ")
                let data = { refreshToken: refreshToken }
                let response = yield authApi.refreshToken(data);
                switch (response.status) {
                    case 1:
                        window.log("!refreshToken result", response)
                        const tokenExpiresMinutes = response.data.tokenExpiresMinutes;
                        yield put({ type: AuthActionTypes.Refresh_Token_Success });
                        Cookies.set("token", response.data.token, tokenExpiresMinutes);
                        Cookies.set("expTokenDateTime", response.data.expDateTime, tokenExpiresMinutes);
                        //Cookies.set("refreshToken", response.data.refreshToken, tokenExpiresMinutes);
                        Cookies.set("tokenExpiresMinutes", response.data.tokenExpiresMinutes);
                        break;
                    case 3 || 4:
                        put({ type: AuthActionTypes.Refresh_Token_Error, message: response.message });
                        yield put({ type: AuthActionTypes.Signout_Request })
                        window.log("token error signout", response.message)
                        break;
                    default:
                        break;
                }
            }
            else {
                window.log("!no need to refreshToken")
            }
        }
        catch (error) {
            window.log('client =>> could not create bet code: ', error);
        }
    }

    yield takeLatest(AuthActionTypes.Refresh_Token_Request, function* ({ data }) {
        //call server
        try {
            console.log("Refresh_Token_Request saga", data)
            yield refreshToken();

        } catch (error) {
            window.log("client ==>> could not refresh token");
        }
    })


    yield takeEvery(MembersActionTypes.Set_Selected_Currency, function* ({ currency }) {
        //call server
        try {
            const { general , betSlip } = yield select();
            Cookies.set('selectedCurrency', currency);///
            let betSlipAmount = (general.betSlipConstants && general.betSlipConstants.betSlipAmountLD && general.betSlipConstants.betSlipAmountUSD) ?
                ((currency.currencyId === Enums.Currency.LiberianDollar) ?
                    general.betSlipConstants.betSlipAmountLD : general.betSlipConstants.betSlipAmountUSD) : 100;
            yield put({ type: BetSlipActionTypes.On_Amount_Change, amount: betSlipAmount })
            yield put({
                type: BetSlipActionTypes.On_Bet_Builder_Amount_Change,
                amount : betSlipAmount
            })

            if (general.betsRestrictions) {
                yield put({ type: BetSlipActionTypes.Update_BetSlip_From_Storage })
            }

        } catch (error) {
            window.log('client ==>> could not set default currency');
        }
    })

    yield takeEvery(MembersActionTypes.Add_Second_Member_Phone_Request, function* () {
        //call server
        try {
            yield refreshToken();
            const { register, member } = yield select();

            let formData = {
                phoneNumber: register.formData.secondPhone,
                code: register.formData.smsCode
            }
            let response = yield membersApi.AddMemberPhone(formData);

            switch (response.status) {
                case 1:
                    let current = member.addPhoneCurrent + 1
                    yield put({ type: MembersActionTypes.Add_Second_Member_Phone_Success, current });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Add_Second_Member_Phone_Error, message: response.message });
                    break;
            }
        } catch (error) {
            window.log('client ==>> could not add member phone');
        }
    })

    yield takeEvery(MembersActionTypes.Validate_Add_Second_Phone_Request, function* ({ data }) {
        //call server
        try {
            yield refreshToken();
            let response = yield registerApi.ValidateAddPhoneNumber(data);

            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Validate_Add_Second_Phone_Success });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Validate_Add_Second_Phone_Error, message: response.message });
                    break;
            }
        } catch (error) {
            window.log('client ==>> could not get phone validation');
        }
    })

    yield takeLatest(MembersActionTypes.Send_Verify_Email_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.SendVerifyEmail(memberData.data);

            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Send_Verify_Email_Success, message: response.message });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Send_Verify_Email_Error, message: response.message });
                    break;
            }
        } catch (error) {
            window.log('client ==>> could not send email');
        }
    })
    yield takeLatest(MembersActionTypes.Member_Details_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let user = Cookies.get('user');
            let response = yield membersApi.UpdateMemberDetails(memberData.data);
            let data = response.data;
            switch (response.status) {
                case 1:
                    let balances = data.memberBalances.reduce((acc, current) => {
                        let currencyName = current.currency.currencyName.split(' ').join('');
                        if (!acc[currencyName]) {
                            acc[currencyName] = {
                                balance: current.balance,
                                currencySymbol: current.currency.currencySymbol,
                                defaultCurrency: current.currency.currencyIsDefault,
                                currencyId: current.currency.currencyId
                            }
                        }
                        return acc;
                    }, {});
                    const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
                    Cookies.set('user', {
                        userName: data.userName,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        email: data.email,
                        balance: balances,
                        bonus: user.bonus,
                        memberPhones: user.memberPhones
                    })

                    yield put({ type: MembersActionTypes.Member_Details_Success, data, message: response.message });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Member_Details_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not update member');
        }
    })
    yield takeLatest(MembersActionTypes.Get_Member_Details_Request, function* () {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.GetMemberDetails();
            let data = response.data;
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Get_Member_Details_Success, data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Get_Member_Details_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not get member');
        }
    })

    yield takeLatest(MembersActionTypes.Mtn_Deposit_Request, function* (request) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.mtnDeposit(request.data);
            let data = response.data;
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Mtn_Deposit_Success, message: response.message, data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Mtn_Deposit_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not deposit mtn');
        }
    })
    yield takeLatest(MembersActionTypes.Orange_Deposit_Request, function* (request) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.orangeDeposit(request.data);
            let data = response.data;
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Orange_Deposit_Success, message: response.message, data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Orange_Deposit_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not deposit mtn');
        }
    })

    yield takeLatest(MembersActionTypes.Deposit_From_Voucher_Request, function* (voucherData) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.DepositFromVoucher({ code: voucherData.voucher });
            let data = response.data
            switch (response.status) {
                case 1:
                    let selectedCurrency = Cookies.get('selectedCurrency');
                    const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
                    let user = Cookies.get('user');

                    let balances = data.memberBalances.reduce((acc, current) => {
                        let currencyName = current.currency.currencyName.split(' ').join('');
                        if (!acc[currencyName]) {
                            acc[currencyName] = {
                                balance: current.balance,
                                currencySymbol: current.currency.currencySymbol,
                                defaultCurrency: current.currency.currencyIsDefault,
                                currencyId: current.currency.currencyId
                            }
                        }
                        return acc;
                    }, {});
                    Cookies.set('user', {
                        userName: user.userName,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        email: user.email,
                        balance: balances,
                        bonus: data.memberDepositBonusBalance,
                        memberPhones: user.memberPhones
                    })

                    let currentCurrency = Object.keys(balances).find((item) => {
                        return balances[item].currencySymbol == selectedCurrency.currencySymbol
                    })

                    Cookies.set('selectedCurrency', balances[currentCurrency]);
                    yield put({ type: MembersActionTypes.Deposit_From_Voucher_Success, message: response.message, balance: balances });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Deposit_From_Voucher_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not voucher dposit');
        }
    })

    yield takeLatest(MembersActionTypes.Mtn_Withdraw_Request, function* (request) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.mtnWithdraw(request.data);
            let data = response.data;
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Mtn_Withdraw_Success, message: response.message, data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Mtn_Withdraw_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not withdraw mtn');
        }
    })

    yield takeLatest(MembersActionTypes.Tipme_Withdraw_Request, function* (request) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.tipmeWithdraw(request.data);
            let data = response.data;
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Tipme_Withdraw_Success, message: response.message, data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Tipme_Withdraw_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not withdraw mtn');
        }
    })

    yield takeLatest(MembersActionTypes.Tipme_Confirm_Withdraw_Request, function* (request) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.tipmeConfirmWithdraw(request.data);
            let data = response.data;
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Tipme_Confirm_Withdraw_Success, message: response.message, data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Tipme_Confirm_Withdraw_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not withdraw mtn');
        }
    })


    yield takeLatest(MembersActionTypes.Orange_Withdraw_Request, function* (request) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.orangeWithdraw(request.data);
            let data = response.data;
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Orange_Withdraw_Success, message: response.message, data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Orange_Withdraw_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not withdraw mtn');
        }
    })

    yield takeLatest(MembersActionTypes.Withdrawal_To_Voucher_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let selectedCurrency = Cookies.get('selectedCurrency');
            let response = yield membersApi.WithdrawalToVoucher({ amount: memberData.data.amount, currencyId: selectedCurrency.currencyId, password: memberData.data.password });
            switch (response.status) {
                case 1:
                    let data = response.data;
                    const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
                    let user = Cookies.get('user');
                    let balances = data.member.memberBalances.reduce((acc, current) => {
                        let currencyName = current.currency.currencyName.split(' ').join('');
                        if (!acc[currencyName]) {
                            acc[currencyName] = {
                                balance: current.balance,
                                currencySymbol: current.currency.currencySymbol,
                                defaultCurrency: current.currency.currencyIsDefault,
                                currencyId: current.currency.currencyId
                            }
                        }
                        return acc;
                    }, {});
                    Cookies.set('user', {
                        userName: user.userName,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        email: user.email,
                        balance: balances,
                        bonus: data.member.memberDepositBonusBalance,
                        memberPhones: user.memberPhones,
                    })

                    let currentCurrency = Object.keys(balances).find((item) => {
                        return balances[item].currencySymbol == selectedCurrency.currencySymbol
                    })
                    yield put({ type: MembersActionTypes.Set_Selected_Currency, currency: balances[currentCurrency] })
                    Cookies.set('selectedCurrency', balances[currentCurrency]);
                    yield put({ type: MembersActionTypes.Withdrawal_To_Voucher_Success, message: response.message, data, balance: balances[currentCurrency].balance });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Withdrawal_To_Voucher_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not witdraw');
        }
    })

    yield takeLatest(MembersActionTypes.Member_Transactions_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let tableData = {
                fromDate: memberData.data.fromDate,
                toDate: memberData.data.toDate,
                pageSize: 10,
                pageIndex: memberData.data.pageIndex,
                currencyId: memberData.data.currencyId
            }
            let response = yield membersApi.MemberTransactions(tableData);
            let data = response.data;

            switch (response.status) {
                case 1:
                    let transactions = [];
                    data.memberTransactions.map((transaction, i) => {
                        let formatedAmount = transaction.transactionAmount;
                        if (formatedAmount < 0) {
                            formatedAmount = Math.abs(formatedAmount)
                        }
                        formatedAmount = transaction.currency.currencySymbol === 'LD' ? formatedAmount.format(0) : formatedAmount.format(2);
                        formatedAmount = transaction.transactionAmount >= 0 ? formatedAmount : `(${formatedAmount})`
                        formatedAmount = transaction.currency.currencySymbol + ' ' + formatedAmount;

                        let formatedBalance = transaction.transactionBalance;
                        if (formatedBalance < 0) {
                            formatedBalance = Math.abs(formatedBalance)
                        }
                        formatedBalance = transaction.currency.currencySymbol === 'LD' ? formatedBalance.format(0) : formatedBalance.format(2);
                        formatedBalance = transaction.transactionBalance > 0 ? formatedBalance : `(${formatedBalance})`
                        formatedBalance = transaction.currency.currencySymbol + ' ' + formatedBalance;
                        const isCreditAmount = transaction.transactionAmount >= 0;
                        const isCreditBalance = transaction.transactionBalance > 0;
                        transactions.push({
                            key: i,
                            date: Utils.formatDate(transaction.transactionDate),
                            type: transaction.transactionType.transactionName,
                            isCreditAmount: isCreditAmount,
                            isCreditBalance: isCreditBalance,
                            voucher: transaction.voucher,
                            reference: transaction.voucher.code ? transaction.voucher.code : transaction.form.formNumber ? transaction.form.formNumber : '',
                            amount: formatedAmount,
                            balance: formatedBalance,
                            formNumber: transaction.form.formNumber,
                            formType: transaction.form.formType
                        })
                    });
                    let total = data.transactionsTotals.totalTransactions
                    let formDateRange = { fromDate: data.fromDate, toDate: data.toDate };
                    yield put({ type: MembersActionTypes.Member_Transactions_Success, transactions, total, formDateRange });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Member_Transactions_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not get voucher transactions');
        }
    })

    yield takeLatest(MembersActionTypes.Member_Forms_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let tableData = {
                statusId: memberData.data.statusId,
                // fromDate: memberData.data.fromDate,
                // toDate: memberData.data.toDate,
                fromDate: memberData.data.fromDate ? memberData.data.fromDate : null,
                toDate: memberData.data.toDate ? memberData.data.toDate : null,
                pageSize: 10,
                pageIndex: memberData.data.pageIndex
            }
            let response = yield membersApi.MemberForms(tableData);
            switch (response.status) {
                case 1:
                    let data = response.data;
                    let forms = [];
                    data.betForms.map((form, i) => {
                        let formatedAmount;
                        if (form.formCurrency.currencySymbol === 'LD') {
                            formatedAmount = form.formCurrency.currencySymbol + form.formAmount.format(0);
                        }
                        else {
                            formatedAmount = form.formCurrency.currencySymbol + form.formAmount.format(2);
                        }
                        let formatedWinAmount;
                        if (form.formCurrency.currencySymbol === 'LD') {
                            formatedWinAmount = form.winAmount ? form.formCurrency.currencySymbol + form.winAmount.format(0) : '-';
                        }
                        else {
                            formatedWinAmount = form.winAmount ? form.formCurrency.currencySymbol + form.winAmount.format(2) : '-';
                        }
                        forms.push({
                            key: i,
                            date: Utils.formatDate(form.formDateTime),
                            formNumber: form.formNumber,
                            amount: formatedAmount,
                            winAmount: formatedWinAmount,
                            status: form.formStatus.formStatusName,
                            formType: form.formType,
                            cashOutOffer: `${form.formCurrency.currencySymbol}${form.cashOutOfferAmount}`,
                            cashOutOfferAmount: form.cashOutOfferAmount,
                            formId: form.formId
                        })
                    });
                    let total = data.formsTotals.totalForms;
                    let formDateRange = { fromDate: data.fromDate, toDate: data.toDate };

                    yield put({ type: MembersActionTypes.Member_Forms_Success, forms, formEvents: data.formEvents, total, formDateRange });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Member_Forms_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not get form transactions');
        }
    })

    yield takeLatest(MembersActionTypes.Forms_Details_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.FormsDetails(memberData.data);
            let data = response.data
            switch (response.status) {
                case 1:
                    let details = [];
                    if (data.isGroupChecking) {
                        data.betFormsDetails.map((form, i) =>
                            details.push({
                                key: i,
                                formNumber: form.formNumber,
                                issueDate: form.formDateTime,
                                winningOdds: form.totalWinningsOdds,
                                sumOfBet: form.formAmount,
                                winningPossible: form.possibleWinnings,
                                formId: form.formId,
                                formStatus: form.formStatus
                            }));
                    }
                    else {
                        data.betFormDetails.fromBetLines.map((form, i) =>
                            details.push({
                                key: i,
                                bet: form.betLineNo,
                                feed: form.feedName,
                                sport: form.sportName,
                                match: form.eventName,
                                note: form.betType.betTypeName,
                                odd: form.odd,
                                mark: form.formMark,
                                correctMark: form.correctMark,
                                gameScore: form.gameScore,
                                status: form.winStatus,
                                formId: form.formId,
                                isFinal: form.isFinal,
                                oddOption: form.oddOption,
                                bonusCorrectMark: form.bonusCorrectMark,
                                selectedBonuses: form.selectedBonuses,
                                wonBonusNumbers: form.wonBonusNumbers,
                                selectedNumbers: form.selectedNumbers,
                            }));
                    }

                    data.earlyCashouts.map((item, i) => {
                        item.cashoutDate = Utils.formatDate(item.cashoutDate)
                    });

                    data.betFormDetails.message = data.messages[0];
                    yield put({ type: MembersActionTypes.Open_Mobile_Table_Details, open: true })
                    yield put({
                        type: MembersActionTypes.Forms_Details_Success, details, isGroup: data.isGroupChecking,
                        betLines: data.betFormDetails, earlyCashouts: data.earlyCashouts , formBonuses: data.formBonuses , isCustomBet: data.betFormDetails && data.betFormDetails.isCustomBet,
                    });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Forms_Details_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not get form details');
        }
    })

    yield takeLatest(MembersActionTypes.Add_Provider_List_Request, function* () {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.addProviderList();
            let data = response.data
            // console.log("responseprovider" , response);
            // console.log("dataprovider" , data);
            // console.log("response.statusprovider",response.status);
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Add_Provider_List_Error, addProviderListErrorMessage: response.message });

            } else if (response.status == 1) {
                yield put({ type: MembersActionTypes.Add_Provider_List_Success, addProviderList: data });

            }

        } catch (error) {
            // console.log("hi");
            yield put({ type: MembersActionTypes.Add_Provider_List_Error, addProviderListErrorMessage: 'Error in getting Add providers' });

            window.log('client ==>> could not get form details');
        }
    })

    yield takeLatest(MembersActionTypes.Member_Add_Provider_List_Request, function* () {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.MemberProvidersList();
            let data = response.data
            // console.log("Memberresponseprovider" , response);
            // console.log("Memberdataprovider" , data);
            // console.log("Memebrresponse.statusprovider",response.status);
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Member_Add_Provider_List_Error, MemberaddProviderListErrorMessage: response.message });

            } else if (response.status == 1) {
                yield put({ type: MembersActionTypes.Member_Add_Provider_List_Success, MemberaddProviderListElements: data });

            }

        } catch (error) {
            // console.log("hi");
            yield put({ type: MembersActionTypes.Member_Add_Provider_List_Error, MemberaddProviderListErrorMessage: 'Error in getting Member Add providers' });

            window.log('client ==>> could not get form details');
        }
    })

    yield takeLatest(MembersActionTypes.Tip_Me_Customer_Search_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.tipMeSearchCustomer(memberData.data);
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Tip_Me_Customer_Search_Error, tipMeCutomerSearchErrorMessage: response.message });

            } else if (response.status == 1) {
                yield put({ type: MembersActionTypes.Tip_Me_Customer_Search_Success, isTipMeNumberValid: response.success, isTipMeNumberValidMessage: response.message, tipMeCutomerSearchErrorMessage: false });

            }

        } catch (error) {
            // console.log("hi");
            yield put({ type: MembersActionTypes.Tip_Me_Customer_Search_Error, tipMeCutomerSearchErrorMessage: error.message });

            window.log('client ==>> could not get form details');
        }
    })

    yield takeLatest(MembersActionTypes.Deposite_Tip_Me_Customer_Search_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.DepositeTipMe(memberData.data);
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Deposite_Tip_Me_Customer_Search_Error, depositeTipMeErrorMessage: response.message });

            } else if (response.status == 1) {
                yield put({ type: MembersActionTypes.Deposite_Tip_Me_Customer_Search_Success, depositeTipMeVertification: response.success, depositeTipMeSuccessMessage: response.message, depositeTipMeEstimateMessage: response.data.estimateMessage });

            }

        } catch (error) {
            // console.log("hi");
            yield put({ type: MembersActionTypes.Deposite_Tip_Me_Customer_Search_Error, depositeTipMeErrorMessage: error.message });

            window.log('client ==>> could not get form details');
        }
    })
    yield takeLatest(MembersActionTypes.Tip_Me_First_Deposit_Message_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.firstDepositeFirstStepMessage(data.data.methodName);
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Tip_Me_First_Deposit_Message_Error, tipMeFirstDepositeMessageError: response.message + `in Tip me message` });

            } else if (response.status == 1) {
                // console.log("I am here",response.data[0].pageMessageText.toString().replaceAll('\n','88')   );
                yield put({ type: MembersActionTypes.Tip_Me_First_Deposit_Message_Success, tipMeFirstDepositeMessage: response.data[0].pageMessageText });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Tip_Me_First_Deposit_Message_Error, tipMeFirstDepositeMessageError: error.message + `in Tip me message` });

            window.log('client ==>> could not get form details');
        }
    })
    yield takeLatest(MembersActionTypes.Tip_Me_OTP_Verification_Request, function* (data, methodName) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.tipMeOTPVertificaton(data.data, data.methodName);
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Tip_Me_OTP_Verification_Error, tipMeOTPErrormessage: response.message + `in OTP verification` });

            } else if (response.status == 1) {
                yield put({ type: MembersActionTypes.Tip_Me_OTP_Verification_Success, tipMeOTPVerificationSuccessMessage: response.message, tipMeOTPErrormessage: false });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Tip_Me_OTP_Verification_Error, tipMeOTPErrormessage: error.message + `in OTP verification` });
        }
    })

    yield takeLatest(MembersActionTypes.Add_Member_Providers_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.AddMemberProviders(data.data);
            if (response.status == 3 || response.status == 4) {
                yield put({ type: MembersActionTypes.Add_Member_Providers_Error, addMemberProviderErrorMessage: response.message });
            } else if (response.status == 1) {
                yield put({ type: MembersActionTypes.Add_Member_Providers_Success, addMemberProviderSuccessMessage: response.message });
            }
        } catch (error) {
            yield put({ type: MembersActionTypes.Add_Member_Providers_Error, addMemberProviderErrorMessage: error.message });
        }
    })
    yield takeLatest(MembersActionTypes.Create_Virtual_Sport_Token_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.CreateVirtualSportToken(data.data);            
            if (response.status == 3 || response.status == 4) {
                yield put({ type: MembersActionTypes.Create_Virtual_Sport_Token_Error, virtualSportTokenErrorMessage: response.message });
            } else if (response.status == 1) {
                yield put({ type: MembersActionTypes.Create_Virtual_Sport_Token_Success, virtualSportToken: response.data && response.data.iframeUrl });
            }
        } catch (error) {
            yield put({ type: MembersActionTypes.Create_Virtual_Sport_Token_Error, virtualSportTokenErrorMessage: 'Something is wrong, please try again Later !' });
        }
    })

    yield takeLatest(MembersActionTypes.Get_Rewards_Request, function* () {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.getRewards();
            let data = response.data
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Get_Rewards_Error, getRewardsErrorMessage: response.message });

            } else if (response.status == 1) {
                yield put({
                    type: MembersActionTypes.Get_Rewards_Success, rewardInfo: data.rewardInfo,
                    rewardsTransactionButtonName: data.rewardsTransactionButtonName, currentLevelRewardsName: data.currentLevelRewardsName,
                    rewardCurrentLevelList: data.rewardCurrentLevelList, slotsRewardList: data.slotsRewardList, slotsRewardsName: data.slotsRewardsName, nextLevelRewardsName: data.nextLevelRewardsName, rewardNextLevelList: data.rewardNextLevelList, howItWorksTitle: data.howItWorksTitle, howItWorksHeadMessage: data.howItWorksHeadMessage, howItWorksLines: data.howItWorksLines, rewardSystemTitle: data.rewardSystemTitle, rewardsSystems: data.rewardsSystems
                });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Get_Rewards_Error, getRewardsErrorMessage: error.message });
        }
    })

    yield takeLatest(MembersActionTypes.Get_Rewards_Transaction_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.getRewardsTransaction(data.data);
            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Get_Rewards_Transaction_Error, rewardsTransactionErrorMessage: response.message });

            } else if (response.status == 1) {
                // console.log("form success--");
                yield put({ type: MembersActionTypes.Get_Rewards_Transaction_Success, rewardsTransactionList: response.data.customerClubRewardTransactions, transactionsTotals: response.data.transactionsTotals });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Get_Rewards_Transaction_Error, rewardsTransactionErrorMessage: error.message });
        }
    })

    yield takeLatest(MembersActionTypes.Get_Club_Reward_Status_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.clubRewardStatus(data.data);

            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Get_Club_Reward_Status_Error, clubRewardStatusError: response.message });

            } else if (response.status == 1) {
                // console.log("form success--");
                yield put({ type: MembersActionTypes.Get_Club_Reward_Status_Success, rewardClubStatus: response.data });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Get_Club_Reward_Status_Error, clubRewardStatusError: error.message });
        }
    })

    yield takeLatest(MembersActionTypes.Get_Club_Member_Reward_Info_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.clubMemberRewardInfo(data.data);

            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Get_Club_Member_Reward_Info_Error, rewardClubInfoError: response.message });

            } else if (response.status == 1) {
                // console.log("form success--");
                yield put({ type: MembersActionTypes.Get_Club_Member_Reward_Info_Success, rewardClubInfo: response.data });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Get_Club_Member_Reward_Info_Error, rewardClubInfoError: error.message });
        }
    })


    yield takeLatest(MembersActionTypes.Customer_Club_Reward_Redeem_Request, function* (data) {
        //call server
        try {
            let response = yield membersApi.customerClubRewardRedeem(data.data);

            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Customer_Club_Reward_Redeem_Error, rewardRedeemError: response.message });

            } else if (response.status == 1) {
                // console.log("form success--");
                yield put({ type: MembersActionTypes.Customer_Club_Reward_Redeem_Success, rewardRedeemResponse: response.data });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Customer_Club_Reward_Redeem_Error, rewardRedeemError: error.message });
        }
    })

    yield takeLatest(MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.getWheelOfFortuneGift(data.data);

            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Error, getFreeSpinGiftsError: response.message });

            } else if (response.status == 1) {
                // console.log("form success--");
                yield put({ type: MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Success, freeSpinGifts: response.data });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Error, getFreeSpinGiftsError: error.message });
        }
    })

    yield takeLatest(MembersActionTypes.Wheel_Of_Fortune_Spin_Request, function* (data) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.wheelOfFortuneSpin(data.data);

            if (response.status == 3 || response.status == 4) {

                yield put({ type: MembersActionTypes.Wheel_Of_Fortune_Spin_Error, wheelSpinError: response.message });

            } else if (response.status == 1) {
                // console.log("form success--");
                yield put({ type: MembersActionTypes.Wheel_Of_Fortune_Spin_Success, freeSpinResult: response.data });

            }

        } catch (error) {
            yield put({ type: MembersActionTypes.Wheel_Of_Fortune_Spin_Error, wheelSpinError: error.message });
        }
    })

    yield takeLatest(MembersActionTypes.Voucher_Details_Request, function* (memberData) {
        //call server
        try {
            yield refreshToken();

            let response = yield membersApi.GetVoucherDetails(memberData.data);
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Voucher_Details_Success, voucherDetails: response.data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Voucher_Details_Error, message: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not get voucher details');
        }
    })

    yield takeEvery(MembersActionTypes.Member_Approved_Jackpot_Winnings_Request, function* ({ jackpotId }) {
        //call server
        try {
            yield refreshToken();

            let data = {
                jackpotId
            }
            let response = yield membersApi.memberApprovedJackpotWinnings(data);

            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Member_Approved_Jackpot_Winnings_Success });
                    yield put({ type: SignalRTypes.Jackpot_Winning_Approved, jackpotWinningApproved: false })

                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Member_Approved_Jackpot_Winnings_Error });
                    break;
                default:
                    yield put({ type: MembersActionTypes.Member_Approved_Jackpot_Winnings_Error });
                    break;
            }

        }
        catch (error) {
            window.log('client =>> could not memberApprovedJackpotWinnings: ', error);
        }
    })

    yield takeEvery(MembersActionTypes.CheckDepositBonusConditions_Request, function* () {
        //call server
        const { general, betSlip } = yield select();
        let currency = Cookies.get('selectedCurrency');
        if (!currency || !currency.currencyId) {
            Cookies.set('selectedCurrency', general.currencies.LiberianDollar)
            currency = Cookies.get('selectedCurrency');
        }
        try {
            yield refreshToken();

            let list = SessionStorage.betSlip ? { ...SessionStorage.betSlip } : {};
            let request = {};
            request.betLines = [];
            request.amount = betSlip.amount;
            request.currencyId = currency.currencyId;
            Object.values(list).map((item) => {
                request.betLines.push({
                    feedId: item.feed.feedId,
                    sportId: item.sport.sportId,
                    eventId: item.eventId,
                    oddId: item.oddId,
                    oddFieldNumber: item.oddFieldNumber,
                    betLineNo: item.eventBetLineNo,
                    betTypeId: item.betType.betTypeId,
                })
            })

            let response = yield membersApi.checkDepositBonusConditions(request);

            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.CheckDepositBonusConditions_Success, conditions: response.data });
                    yield put({
                        type: BetSlipActionTypes.Set_BetSlip_Possible_Winnings,
                        possibleWinnings: response.data.possibleWinnings
                    })
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.CheckDepositBonusConditions_Error, message: response.message });
                    yield put({
                        type: BetSlipActionTypes.Set_BetSlip_Value_Change_Warning,
                        valueChangeWarning: response.message
                    })
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not checkDepositBonusConditions');
        }
    })

    yield takeEvery(MembersActionTypes.CreateCustomerServiceCode_Request, function* () {
        try {
            yield refreshToken();

            let response = yield membersApi.createCustomerServiceCode();
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.CreateCustomerServiceCode_Success, customerServiceCode: response.data.code });
                    let expiresMinutes = response.data.customerServiceCodeExpiresMinutes ? response.data.customerServiceCodeExpiresMinutes : 15;
                    Cookies.set('customerServiceCode', response.data.code, expiresMinutes);
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.CreateCustomerServiceCode_Error, message: response.message });

                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not CreateCustomerServiceCode');
        }
    })

    yield takeEvery(MembersActionTypes.Get_Sign_In_Loyalty_Rewards_Options_Request, function* () {
        try {
            yield refreshToken();

            let response = yield membersApi.getSignedInLoyalityRewards();
            switch (response.status) {
                case 1:
                    yield put({ type: GeneralActionTypes.Get_Loyalty_Rewards_Options_Success, loyalityRewardOptions: response.data.loyaltyRewardsOptions });
                    break;
                case 3 || 4:
                    yield put({ type: GeneralActionTypes.Get_Loyalty_Rewards_Options_Error, loyalityRewardOptionsError: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not CreateCustomerServiceCode');
        }
    })
    yield takeEvery(MembersActionTypes.Get_Loyalty_Rewards_Coupons_Request, function* (data) {
        try {
            yield refreshToken();

            let response = yield membersApi.GetLoyaltyRewardsCoupons(data.data);
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Get_Loyalty_Rewards_Coupons_Success, loyaltyCoupons: response.data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Get_Loyalty_Rewards_Coupons_Error, loyaltyCouponsError: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not CreateCustomerServiceCode');
        }
    })
    yield takeEvery(MembersActionTypes.Create_Member_Slots_Bonus_Request, function* ({ data }) {

        try {
            yield refreshToken();
            console.log("data in CreateMemberSlotsBonus", data);
            let response = yield membersApi.CreateMemberSlotsBonus(data);
            console.log("response in CreateMemberSlotsBonus", response);
            switch (response.status) {
                case 1:
                    yield put({ type: MembersActionTypes.Create_Member_Slots_Bonus_Success, createMemberSlotsInfo: response.data });
                    break;
                case 3 || 4:
                    yield put({ type: MembersActionTypes.Create_Member_Slots_Bonus_Error, createMemberSlotsError: response.message });
                    break;
                default:
            }
        } catch (error) {
            window.log('client ==>> could not CreateCustomerServiceCode');
        }
    })

yield takeEvery(MembersActionTypes.Get_Last_Reward_Notifications_Request, function* () {

    try {
        yield refreshToken();
        let response = yield membersApi.GetLastRewardNotifications();
        switch (response.status) {
            case 1:
                yield put({ type: MembersActionTypes.Get_Last_Reward_Notifications_Success, rewardNotifications: response.data });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Get_Last_Reward_Notifications_Error, rewardNotificationError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})
yield takeEvery(MembersActionTypes.Get_Notification_History_Request, function* ({data}) {

    try {
        yield refreshToken();
        let response = yield membersApi.GetNotificationHistory(data);

        switch (response.status) {
            case 1:
                
                yield put({ type: MembersActionTypes.Get_Notification_History_Success, notficationHistory: response.data });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Get_Notification_History_Error, notficationHistoryError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})
yield takeEvery(MembersActionTypes.Delete_Notification_Request, function* ({data}) {

    try {
        yield refreshToken();
        let response = yield membersApi.DeleteNotification(data.data);

        switch (response.status) {
            case 1:
                yield put({type: MembersActionTypes.Get_Notification_History_Request ,data: data.getNotificationData })
                if(data.isUnRead) yield put({type: MembersActionTypes.Get_Notification_Count_Request})
                yield put({ type: MembersActionTypes.Delete_Notification_Success });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Delete_Notification_Error, deleteNotificationError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})
yield takeLatest(MembersActionTypes.Get_Notification_Count_Request, function* () {

    try {
        yield refreshToken();
        let response = yield membersApi.GetNotificationCount();

        switch (response.status) {
            case 1:
                yield put({ type: MembersActionTypes.Get_Notification_Count_Success , notificationCount: response.data.unreadNotificationCount  });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Get_Notification_Count_Error, getNotificationError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})
yield takeLatest(MembersActionTypes.Mute_Notification_Request, function* ({data}) {

    try {
        yield refreshToken();
        let response = yield membersApi.MuteNotification(data);

        switch (response.status) {
            case 1:
                Cookies.set("isNotificationMuted", data.muteNotification);
                yield put({ type: MembersActionTypes.Mute_Notification_Success , muteNofification: response  });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Mute_Notification_Error, muteNofificationError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})

yield takeEvery(MembersActionTypes.Get_Form_Cash_Out_Offer_Request, function* ({ data }) {

    try {
        yield refreshToken();
        let response = yield membersApi.getFormCashOutOffer(data);
        switch (response.status) {
            case 1:
                const { member } = yield select();
                let isFormChange = false;
                console.log("forms", member.Add_Member_Providers_Errorforms)

                let forms = member.forms;
                forms.forEach((form) => {
                    if (form.formId == response.data.formId) {
                        isFormChange = true;
                        form.cashOutOffer = `${response.data.currencyCode} ${response.data.cashOutOfferAmount}`
                        form.cashOutOfferAmount = response.data.cashOutOfferAmount;
                    }
                });
                if (isFormChange) {
                    yield put({ type: MembersActionTypes.Member_Forms_Change, forms: forms });

                }
                yield put({ type: MembersActionTypes.Get_Form_Cash_Out_Offer_Success, cashOutOffer: response.data, message: response.message });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Get_Form_Cash_Out_Offer_Error, cashOutOfferError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not getFormCashOutOffer');
    }
})


yield takeEvery(MembersActionTypes.Early_Cash_Out_Request, function* ({ data }) {

    try {
        yield refreshToken();
        let response = yield membersApi.earlyCashOut(data);
        switch (response.status) {
            case 1:
                yield put({ type: MembersActionTypes.Early_Cash_Out_Success, message: response.message });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Early_Cash_Out_Error, cashOutOfferError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not earlyCashOut');
    }
})

yield takeEvery(MembersActionTypes.Get_Notification_Details_Request, function* ({data}) {

    try {
        yield refreshToken();
        let response = yield membersApi.NotificationDetails(data.request);

        switch (response.status) {
            case 1:
                if(data.unReadNotification)  yield put({ type: MembersActionTypes.Get_Notification_Count_Request });
                yield put({ type: MembersActionTypes.Get_Notification_Details_Success, notificationDetails: response.data });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Get_Notification_Details_Error, notificationDetailsError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})
yield takeEvery(MembersActionTypes.Read_Notification_Status_Request, function* ({data}) {

    try {
        let response = yield membersApi.ReadNotificationStatus(data);

        switch (response.status) {
            case 1:
                yield put({ type: MembersActionTypes.Read_Notification_Status_Success });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Read_Notification_Status_Error, ReadNotificationStatusError: response.message });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})
yield takeEvery(MembersActionTypes.Manage_Memeber_Favorite_Request, function* ({data}) {

    try {
        let response = yield membersApi.ManageMemeberFavorite(data);
        console.log("response of Manage_Memeber_Favorite",response);

        switch (response.status) {
            case 1:
                let data=[];
                response.data.map(item=>{
                    data.push({favoriteId: item.favoriteId , entityType:item.favoriteType && item.favoriteType.favoriteTypeId , entityId: item.elementId , sportId: item.sportId , key:`${item.favoriteType && item.favoriteType.favoriteTypeId}-${item.elementId}-${item.sportId}`, feedId:item.feedId})
                })
                let favoriteEntities= data.map(item =>  {return {entityType: item.entityType , entityId:  item.entityId, feedId:item.feedId , sportId: item.sportId }})
                localStorage.setItem("memberFavorites",JSON.stringify(data))
                localStorage.setItem("favoriteEntities",JSON.stringify(favoriteEntities))
                yield put({ type: MembersActionTypes.Manage_Memeber_Favorite_Success });
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Manage_Memeber_Favorite_Error });
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateCustomerServiceCode');
    }
})
yield takeEvery(MembersActionTypes.Create_Member_Slots_Bonus_By_Coupon_Code_Request, function* ({data}) {

    try {
        let response = yield membersApi.CreateMemberSlotsBonusByCouponCode(data);
        console.log("response of Create_Member_Slots_Bonus_By_CouponCode",response);

        switch (response.status) {
            case 1:
                yield put({ type: MembersActionTypes.Create_Member_Slots_Bonus_By_Coupon_Code_Success });
                Utils.navigateTo(`/slots/game/${data.gameId}/1`)
                SessionStorage.couponCode = false;
                break;
            case 3 || 4:
                yield put({ type: MembersActionTypes.Create_Member_Slots_Bonus_By_Coupon_Code_Error , message : response.message});
                break;
            default:
        }
    } catch (error) {
        window.log('client ==>> could not CreateMemberSlotsBonusByCouponCode');
    }
})


}

export default function* MembersSaga() {
    yield all([
        fork(requests)
    ])
}
